export default __webpack_public_path__ + "static/media/bar-plugin-d@3x.65060548.png";